import { JobDetailsDrawer } from '@client/components/_business/jobs/JobDetailsDrawer';
import { PageController } from '@client/components/_core/layout/PageController';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

export const Route = createFileRoute('/admin-console/advanced/jobs/on-demand/$jobId')({
    staticData: {
        presentation: 'overlay',
        breadcrumb: { title: 'On-Demand Job Details' },
        ui: {
            title: 'On-Demand Job Details',
        },
    },
    component: OnDemandJobDetail,
});

function OnDemandJobDetail() {
    const { jobId } = Route.useParams();
    const navigate = useNavigate();
    const [open, setOpen] = useState(true);

    const handleClose = () => {
        setOpen(false);
        // Navigate back to the on-demand jobs list after drawer animation
        setTimeout(() => {
            navigate({ to: '/admin-console/advanced/jobs/on-demand' });
        }, 300);
    };

    return (
        <PageController route={Route}>
            <JobDetailsDrawer jobId={jobId} jobType="on-demand" open={open} onClose={handleClose} />
        </PageController>
    );
}
